import { createSlice } from '@reduxjs/toolkit';

import { status } from 'utils/const';
import { thunks } from './thunks';
import { selectors } from './selectors';

const defaultValues = {
  role: { label: '', value: '' },
  parentName: { label: '', value: '' },
  dancerName: { label: '', value: '' },
};

const initialState = {
  list: [],
  teamsListLoaded: false,
  employees: {},
  pagination: {
    current: 1,
    total: 0,
  },
  filters: {
    fields: defaultValues,
    updatedFields: 0,
  },
  loadingListStatus: status.IDLE,
  loadingMember: status.IDLE,
  employeeDetailsLoaded: false,
  submitNewMemberStatus: status.IDLE,
  loadingEditedMember: status.IDLE,
};

const slice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    setFilters: (state, { payload }) => {
      let updatedFieldsCount = 0;
      const defaultValues = Object.values(initialState.filters.fields);

      Object.values(payload).forEach((field, index) => {
        if (field.label !== defaultValues[index].label) {
          updatedFieldsCount += 1;
        }
      });

      state.filters.updatedFields = updatedFieldsCount;
      state.filters.fields = payload;
    },
    setPage: (state, { payload }) => {
      state.pagination.current = payload;
    },
    setTeamsListLoaded: (state, { payload }) => {
      state.teamsListLoaded = payload;
    },
    setEmployeeDetailsLoaded: (state, { payload }) => {
      state.employeeDetailsLoaded = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.getTeamsList.pending, (state) => {
        state.loadingListStatus = status.PENDING;
        state.teamsListLoaded = false;
      })
      .addCase(thunks.getTeamsList.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.pagination.total = action.payload.meta.total;
        state.loadingListStatus = status.SUCCESS;
        state.teamsListLoaded = true;
      })
      .addCase(thunks.getTeamsList.rejected, (state) => {
        state.loadingListStatus = status.FAIL;
        state.teamsListLoaded = false;
      })

      .addCase(thunks.createMember.pending, (state) => {
        state.submitNewMemberStatus = status.PENDING;
      })
      .addCase(thunks.createMember.fulfilled, (state) => {
        state.submitNewMemberStatus = status.SUCCESS;
      })
      .addCase(thunks.createMember.rejected, (state) => {
        state.submitNewMemberStatus = status.FAIL;
      })

      .addCase(thunks.getEmployees.pending, (state) => {
        state.loadingMember = status.PENDING;
      })
      .addCase(thunks.getEmployees.fulfilled, (state, action) => {
        state.employees = action.payload.data;
        state.loadingMember = status.SUCCESS;
        state.employeeDetailsLoaded = true;
      })
      .addCase(thunks.getEmployees.rejected, (state) => {
        state.loadingMember = status.FAIL;
      })

      .addCase(thunks.editEmployees.pending, (state) => {
        state.loadingEditedMember = status.PENDING;
      })
      .addCase(thunks.editEmployees.fulfilled, (state) => {
        state.loadingEditedMember = status.SUCCESS;
      })
      .addCase(thunks.editEmployees.rejected, (state) => {
        state.loadingEditedMember = status.FAIL;
      });
  },
});

const team = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { team };
export default slice.reducer;
